<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11215_236928)">
      <path
        d="M6 11.4375C9.00305 11.4375 11.4375 9.00305 11.4375 6C11.4375 2.99695 9.00305 0.5625 6 0.5625C2.99695 0.5625 0.5625 2.99695 0.5625 6C0.5625 9.00305 2.99695 11.4375 6 11.4375Z"
        stroke="#DC0024"
        stroke-width="1.125"
      />
      <path
        d="M6.5625 2.625H5.4375V3.75H6.5625V2.625Z"
        fill="#DC0024"
      />
      <path
        d="M6.5625 4.5H5.4375V9.375H6.5625V4.5Z"
        fill="#DC0024"
      />
    </g>
    <defs>
      <clipPath id="clip0_11215_236928">
        <rect
          width="12"
          height="12"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
</script>
